import { Easing, withDelay, withRepeat, withSequence, withTiming } from 'react-native-reanimated';

export const AUTOPLAY_CARD_DURATION = 5200;
export const AUTOPLAY_ROUND_PAUSE = 2000;

export function autoplayCarouselFrom(start: number, count: number) {
  'worklet';
  // Ease the full revolution so it accelerates away from rest and decelerates
  // back into the starting arrangement. The identical end pose can then hold
  // for two seconds before the next revolution begins without a visual reset.
  return withRepeat(
    withSequence(
      withTiming(start + count, {
        duration: AUTOPLAY_CARD_DURATION * count,
        easing: Easing.bezier(0.42, 0, 0.58, 1),
      }),
      withDelay(AUTOPLAY_ROUND_PAUSE, withTiming(start + count, { duration: 0 })),
    ),
    -1,
    false,
  );
}
